






























import {
  createComponent,
  ref,
  watch,
  onMounted,
  //eslint-disable-next-line
  Ref,
  computed
} from "@vue/composition-api";
//eslint-disable-next-line
import {
  //eslint-disable-next-line
  SliderMap,
  findNearestPercentage,
  getTransparentImage,
  buildSliderMap
} from "../common/sliderUtils";
import { getYourGoalText, getYouNowText } from "@dcc/constants/sliderConstants";

interface SliderProps {
  value: number;
}

export default createComponent({
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  setup(props: SliderProps, { emit }) {
    const slider: Ref<HTMLElement | null> = ref(null);
    const bar: Ref<HTMLElement | null> = ref(null);
    const drag: Ref<HTMLElement | null> = ref(null);

    const sliderMap: Ref<SliderMap> = ref({});

    const startPercentage = props.value;

    const updatePercentage = (sliderMap: SliderMap, x: number) => {
      const newPercentage = findNearestPercentage({
        sliderMap,
        startPercentage,
        currentX: x
      });
      emit("input", newPercentage);
    };

    const handleDragOver = (e: DragEvent) =>
      updatePercentage(sliderMap.value, e.x);

    const updateSliderStyles = (percentage: number) => {
      if (bar.value && drag.value) {
        bar.value.style.backgroundImage = `linear-gradient(to right, #ffc84e ${percentage}%, rgba(207, 222, 245, 0.3) ${percentage}%)`;
        drag.value.style.right = `${100 - percentage}%`;
      }
    };

    watch(
      () => props.value,
      percentage => {
        updateSliderStyles(percentage);
      }
    );

    onMounted(() => {
      updateSliderStyles(props.value);
    });

    const sliderText = computed(() =>
      props.value < startPercentage ? getYourGoalText() : getYouNowText()
    );

    const handleDragStart = (e: DragEventInit) => {
      if (e.dataTransfer) {
        e.dataTransfer.setDragImage(getTransparentImage(), 10, 10);
      }
      if (slider.value) {
        const sliderRect = slider.value.getBoundingClientRect();
        sliderMap.value = buildSliderMap(sliderRect);
      }
    };

    const handleClick = (e: MouseEvent) => {
      if (slider.value) {
        const sliderRect = slider.value.getBoundingClientRect();
        const sliderMap = buildSliderMap(sliderRect);
        updatePercentage(sliderMap, e.x);
      }
    };

    return {
      handleDragStart,
      handleDragOver,
      handleClick,
      bar,
      slider,
      drag,
      sliderText
    };
  }
});
